
/**
 * 格式化时间戳为日期文本
 * @param timestamp
 * @returns {string}
 */
export function formatDateText(timestamp) {
  if (!timestamp) return '';
  const date = new Date(parseInt(timestamp));
  const now = new Date();

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const yesterdayStart = todayStart - 24 * 60 * 60 * 1000;
  const days7AgoStart = todayStart - 7 * 24 * 60 * 60 * 1000;

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  if (date.getTime() >= todayStart) {
    return `${hours}:${minutes}`;
  }
  if (date.getTime() >= yesterdayStart) {
    return '昨天';
  }
  if (date.getTime() >= days7AgoStart) {
    const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    return weekDays[date.getDay()];
  }
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  let year = date.getFullYear();
  if (now.getFullYear() !== year) {
    return `${year}/${month}/${day}`;
  }
  return `${month}/${day}`;
}

/**
 * 格式化时间戳为日期和时间文本
 * @param timestamp
 * @returns {string}
 */
export function formatDateAndTimeText(timestamp) {
  if (!timestamp) return '';
  const date = new Date(parseInt(timestamp));
  const now = new Date();

  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const yesterdayStart = todayStart - 24 * 60 * 60 * 1000;
  const days7AgoStart = todayStart - 7 * 24 * 60 * 60 * 1000;

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  if (date.getTime() >= todayStart) {
    return `${hours}:${minutes}`;
  }
  if (date.getTime() >= yesterdayStart) {
    return `昨天 ${hours}:${minutes}`;
  }
  if (date.getTime() >= days7AgoStart) {
    const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    return `${weekDays[date.getDay()]} ${hours}:${minutes}`;
  }
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  let year = date.getFullYear();
  if (now.getFullYear() !== year) {
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  }
  return `${month}月${day}日 ${hours}:${minutes}`;
}

export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}